import React, { useEffect, useState } from "react";
import "./MainGasFlame.css";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";


function MainGasFlame({

  pilotOn = false,

  PT_2104 = 0,
  PT_2103 = 0,

  x = 200,
  y = 200,

  width = 260,
  height = 220,

}) {


const [mainFlameOn, setMainFlameOn] = useState(false);



/* =================================================
   PRESSURE VALUES
================================================= */


const cngPressure =
Number(PT_2104) || 0;


const methanePressure =
Number(PT_2103) || 0;



/*
   Select strongest fuel source

   If CNG = 0.2
   Methane = 0.7

   Flame uses 0.7
*/

const fuelPressure =
Math.max(
  cngPressure,
  methanePressure
);



/* =================================================
   FUEL AVAILABLE
================================================= */


const fuelAvailable =
fuelPressure > 0.05;



/* =================================================
   MAIN FLAME LOGIC
================================================= */


useEffect(()=>{


/*
  Start condition:

  Pilot ON
  +
  Fuel pressure available
*/

if(
 pilotOn &&
 fuelAvailable
){

setMainFlameOn(true);

}



/*
  Safety shutdown

  No fuel
*/

if(!fuelAvailable){

setMainFlameOn(false);

}


},[
pilotOn,
fuelAvailable
]);



/* =================================================
   SAVE MAIN FLAME STATUS
================================================= */

useEffect(() => {

    PlantStore.set({

        transmitters: {

            ...PlantStore.get().transmitters,

            MAIN_FLAME_ON: mainFlameOn

        }

    });

}, [mainFlameOn]);


/* =================================================
   FLAME SIZE CONTROL
================================================= */


/*
 Minimum flame starts at 0.05

 Maximum design fuel = 0.970
*/


const MIN_PRESSURE = 0.05;

const MAX_PRESSURE = 0.970;



const fuelRatio =
Math.max(

0,

Math.min(

(fuelPressure - MIN_PRESSURE)
/
(MAX_PRESSURE - MIN_PRESSURE),

1

)

);





/*
 Height:

0.05  = 35%
0.970 = 100%

*/


const flameHeightScale =
0.35 +
(
 fuelRatio * 0.65
);





/*
 Width:

0.05  = small
0.970 = full burner width

*/


const flameWidthScale =
0.45 +
(
 fuelRatio * 0.55
);





/*
 Keep flame base fixed

*/

const flameMoveY =
height -
(
 height *
 flameHeightScale
);






return (


<div


style={{


position:"absolute",

left:x,

top:y,

width,

height,

zIndex:500,

pointerEvents:"none"


}}


>



<svg

width={width}

height={height}

viewBox="0 0 120 220"

>



<defs>




<radialGradient id="mainGasOuter">


<stop

offset="0%"

stopColor="#ffffff"

/>



<stop

offset="25%"

stopColor="#ffff00"

/>



<stop

offset="60%"

stopColor="#ff9900"

/>



<stop

offset="100%"

stopColor="#ff2200"

/>


</radialGradient>






<radialGradient id="mainGasInner">


<stop

offset="0%"

stopColor="white"

/>



<stop

offset="100%"

stopColor="#ffff33"

/>


</radialGradient>




</defs>






{

mainFlameOn &&


<g


className="main-flame"


style={{


transformOrigin:
"60px 220px",



transform:


`

translateY(${flameMoveY}px)

scale(

${flameWidthScale},

${flameHeightScale}

)

`


}}


>




{/* OUTER GAS FLAME */}


<path


d="

M60 220

C20 175 25 120 55 80

C45 45 75 20 70 0

C120 60 110 140 90 185

C80 210 65 220 60 220Z


"


fill="url(#mainGasOuter)"


/>






{/* INNER HOT CORE */}


<path


d="

M60 210

C45 165 55 130 70 90

C90 135 90 170 75 200

C70 210 65 215 60 210Z


"


fill="url(#mainGasInner)"


/>





</g>



}



</svg>




</div>


);


}


export default MainGasFlame;